var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUninstall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.12 272.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.42,229.69l-37.73,37.73a16,16,0,0,1-22.64,0L4.69,65.07a16,16,0,0,1,0-22.65L25.25,21.86,42.42,4.69a16,16,0,0,1,22.65,0L267.42,207.05A16,16,0,0,1,267.42,229.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.36,
    y: -23.04,
    width: 85.39,
    height: 318.2,
    rx: 16.01,
    transform: "translate(136.06 328.47) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUninstall);
export default __webpack_public_path__ + "static/media/uninstall.fbef0d316fbffee61bbe513b96e8e659.svg";
export { ForwardRef as ReactComponent };